<template>
 <div class="bg-white rounded-lg shadow">
  <apexchart
   width="100%"
   :options="chartOptions"
   :series="series" />
 </div>
</template>

<script>
export default {
 name: "DonutChart",
 props: {
  series: {
   type: Array,
   required: true,
  },
  labels: {
   type: Array,
   default: () => ["Connected Time", "Available but Idle", "Unavailable"],
  },
  title: {
   type: String,
   default: "Daily Time Breakdown",
  },
 },
 computed: {
  chartOptions() {
   return {
    chart: {
     type: "donut",
     toolbar: { show: false },
    },
    plotOptions: {
     pie: {
      donut: {
       size: "45%",
       labels: {
        show: true,
        
       },
      },
     },
    },
    labels: this.labels,
    // colors: ["#00E396", "#FEB019", "#FF4560"],
    responsive: [
     {
      breakpoint: 480,
      options: {
       chart: { width: 200 },
       legend: { position: "bottom" },
      },
     },
    ],
    title: {
     text: this.title,
     align: "center",
     style: {
      fontSize: "16px",
      color: "#333",
     },
    },
    tooltip: {
     y: {
      formatter: function (val) {
       return val + " minutes";
      },
     },
    },
   };
  },
 },
};
</script>
